export default __webpack_public_path__ + "static/media/ic_star.46190273.svg";